import { FC, useEffect, useState } from 'react';
import { SurveyWrapperProps } from './SurveyWrapper.types';
import { StyledSection } from './SurveyWrapper.styles';
import { updateDatalayer } from '../../util/dataLayer/datalayerUtil';
import { Text, Types } from '@marriott/mi-ui-library';

export const SurveyWrapper: FC<SurveyWrapperProps> = (props: SurveyWrapperProps) => {
  const { colorScheme } = props;
  // Push marsha code to datalayer
  if (typeof window !== 'undefined' && props.marshaCode) {
    updateDatalayer('prop_marsha_code', props.marshaCode);
  }
  // push alternate id
  if (typeof window !== 'undefined' && props.alternateId) {
    updateDatalayer('mr_id_alternate', props.alternateId);
  }
  // push product
  if (typeof window !== 'undefined' && props.productInfo) {
    updateDatalayer('prop_marsha_code', props.productInfo);
  }
  //push form page name
  if (typeof window !== 'undefined' && props.formPageName) {
    updateDatalayer('form_step_name', props.formPageName);
  }
  //push when submit the form LPA Survey
  if (typeof window !== 'undefined' && props.formName) {
    updateDatalayer('form_name', props.formName);
  }
  //Push added to plan carousel
  if (typeof window !== 'undefined' && props.prearrival_form_amenities_added_to_plan) {
    updateDatalayer('prearrival_form_added_to_plan', props.prearrival_form_amenities_added_to_plan.join('|'));
  }
  //Push arrival date and confirmation number
  if (typeof window !== 'undefined' && props.prearrival_form_booking_confirmation_id) {
    updateDatalayer('res_confirmation_number', props.prearrival_form_booking_confirmation_id);
  }

  //Push error code
  if (typeof window !== 'undefined' && props.env_api_tile_error_info) {
    updateDatalayer('env_api_tile_error_info', props.env_api_tile_error_info);
  }

  //Push point code
  if (typeof window !== 'undefined' && props.form_prearrival_questions_complete) {
    updateDatalayer('form_prearrival_questions_complete', props.form_prearrival_questions_complete);
  }

  const [colorSchemeSet, setColorSchemeSet] = useState<string>('');
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined' && colorScheme) {
      setColorSchemeSet(colorScheme);
    }
    setBackgroundImageUrl(
      `url(${props.backgroundImage}?output-quality=70&interpolation=progressive-bilinear&downsize=*:1000px)`
    );
  }, [colorScheme, props?.backgroundImage]);

  return (
    <>
      {props?.beforeSuveryWrapperOuter && (
        <Text
          element={Types.tags.div}
          fontSize={Types.size.medium}
          dangerouslySetInnerHTML={{
            __html: props?.beforeSuveryWrapperOuter,
          }}
          customClass="box-section-model"
        ></Text>
      )}
      <StyledSection id="main_content" className={props.className}>
        <div
          className="survey-wrapper__background"
          style={{ backgroundImage: backgroundImageUrl ? backgroundImageUrl : 'none' }}
        >
          <div className={'survey-wrapper__children ' + colorSchemeSet}>{props.children}</div>
        </div>
      </StyledSection>
      {props?.afterSuveryWrapperOuter && (
        <Text
          element={Types.tags.div}
          fontSize={Types.size.medium}
          dangerouslySetInnerHTML={{
            __html: props?.afterSuveryWrapperOuter,
          }}
          customClass="box-section-model"
        ></Text>
      )}
    </>
  );
};
